module.exports = __webpack_public_path__ + "img/people_voting.129a7007.jpg";